import {MonitorReducer, ReducerFromState} from "../../../@types/reducers";
import {BooksObject} from "../../../@types/response";

export default (state: ReducerFromState<MonitorReducer>): BooksObject[] => state.monitor.books;